import { render, staticRenderFns } from "./dynamic-form.vue?vue&type=template&id=216db353&scoped=true"
import script from "./dynamic-form.vue?vue&type=script&lang=js"
export * from "./dynamic-form.vue?vue&type=script&lang=js"
import style0 from "./dynamic-form.vue?vue&type=style&index=0&id=216db353&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216db353",
  null
  
)

export default component.exports